import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Container_engine;

import { animate, cancelAnimation } from "../Utils/Utils";
import { Canvas } from "./Canvas";
import { EventListeners } from "./Utils/EventListeners";
import { FrameManager } from "./Utils/FrameManager";
import { Options } from "../Options/Classes/Options";
import { Particles } from "./Particles";
import { Retina } from "./Retina";
import { Vector } from "./Utils/Vector";
import { getRangeValue } from "../Utils/NumberUtils";
export var Container =
/*#__PURE__*/
function () {
  function Container(engine, id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;

    _Container_engine.set(this, void 0);

    __classPrivateFieldSet(this, _Container_engine, engine, "f");

    this.fpsLimit = 120;
    this.duration = 0;
    this.lifeTime = 0;
    this.firstStart = true;
    this.started = false;
    this.destroyed = false;
    this.paused = true;
    this.lastFrameTime = 0;
    this.zLayers = 100;
    this.pageHidden = false;
    this._sourceOptions = sourceOptions;
    this._initialSourceOptions = sourceOptions;
    this.retina = new Retina(this);
    this.canvas = new Canvas(this);
    this.particles = new Particles(__classPrivateFieldGet(this, _Container_engine, "f"), this);
    this.drawer = new FrameManager(this);

    for (var _len = arguments.length, presets = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      presets[_key - 3] = arguments[_key];
    }

    this.presets = presets;
    this.pathGenerator = {
      generate: function generate() {
        var v = Vector.create(0, 0);
        v.length = Math.random();
        v.angle = Math.random() * Math.PI * 2;
        return v;
      },
      init: function init() {},
      update: function update() {}
    };
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this.density = 1;
    this._options = new Options(__classPrivateFieldGet(this, _Container_engine, "f"));
    this.actualOptions = new Options(__classPrivateFieldGet(this, _Container_engine, "f"));
    this.eventListeners = new EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        return _this.intersectionManager(entries);
      });
    }
  }

  _createClass(Container, [{
    key: "play",
    value: function play(force) {
      var needsUpdate = this.paused || force;

      if (this.firstStart && !this.actualOptions.autoPlay) {
        this.firstStart = false;
        return;
      }

      if (this.paused) {
        this.paused = false;
      }

      if (needsUpdate) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref2 = _slicedToArray(_ref3, 2);

            var plugin = _ref2[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      this.draw(needsUpdate || false);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.drawAnimationFrame !== undefined) {
        cancelAnimation()(this.drawAnimationFrame);
        delete this.drawAnimationFrame;
      }

      if (this.paused) {
        return;
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.plugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref6 = _step2.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var plugin = _ref5[1];

          if (plugin.pause) {
            plugin.pause();
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!this.pageHidden) {
        this.paused = true;
      }
    }
  }, {
    key: "draw",
    value: function draw(force) {
      var _this2 = this;

      var refreshTime = force;
      this.drawAnimationFrame = animate()(function _callee(timestamp) {
        return _regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (refreshTime) {
                  _this2.lastFrameTime = undefined;
                  refreshTime = false;
                }

                _context.next = 3;
                return _regeneratorRuntime.awrap(_this2.drawer.nextFrame(timestamp));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this.paused && !this.pageHidden;
    }
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      this.setPath(noiseOrGenerator, init, update);
    }
  }, {
    key: "setPath",
    value: function setPath(pathOrGenerator, init, update) {
      var _a, _b, _c;

      if (!pathOrGenerator) {
        return;
      }

      if (typeof pathOrGenerator === "function") {
        this.pathGenerator.generate = pathOrGenerator;

        if (init) {
          this.pathGenerator.init = init;
        }

        if (update) {
          this.pathGenerator.update = update;
        }
      } else {
        var oldGenerator = this.pathGenerator;
        this.pathGenerator = pathOrGenerator;
        (_a = this.pathGenerator).generate || (_a.generate = oldGenerator.generate);
        (_b = this.pathGenerator).init || (_b.init = oldGenerator.init);
        (_c = this.pathGenerator).update || (_c.update = oldGenerator.update);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.canvas.destroy();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.drawers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref9 = _step3.value;

          var _ref8 = _slicedToArray(_ref9, 2);

          var drawer = _ref8[1];

          if (drawer.destroy) {
            drawer.destroy(this);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.drawers.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var key = _step4.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.destroyed = true;
    }
  }, {
    key: "exportImg",
    value: function exportImg(callback) {
      this.exportImage(callback);
    }
  }, {
    key: "exportImage",
    value: function exportImage(callback, type, quality) {
      var _a;

      return (_a = this.canvas.element) === null || _a === void 0 ? void 0 : _a.toBlob(callback, type !== null && type !== void 0 ? type : "image/png", quality);
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration() {
      return JSON.stringify(this.actualOptions, undefined, 2);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.stop();
      return this.start();
    }
  }, {
    key: "reset",
    value: function reset() {
      this._options = new Options(__classPrivateFieldGet(this, _Container_engine, "f"));
      return this.refresh();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.started) {
        return;
      }

      this.firstStart = true;
      this.started = false;
      this.eventListeners.removeListeners();
      this.pause();
      this.particles.clear();
      this.canvas.clear();

      if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
        this.intersectionObserver.unobserve(this.interactivity.element);
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.plugins[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref12 = _step5.value;

          var _ref11 = _slicedToArray(_ref12, 2);

          var plugin = _ref11[1];

          if (plugin.stop) {
            plugin.stop();
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.plugins.keys()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var key = _step6.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.particles.linksColors = new Map();
      delete this.particles.grabLineColor;
      delete this.particles.linksColor;
      this._sourceOptions = this._options;
    }
  }, {
    key: "loadTheme",
    value: function loadTheme(name) {
      return _regeneratorRuntime.async(function loadTheme$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.currentTheme = name;
              _context2.next = 3;
              return _regeneratorRuntime.awrap(this.refresh());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "start",
    value: function start() {
      var _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _ref15, _ref14, plugin;

      return _regeneratorRuntime.async(function start$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.started) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _context3.next = 4;
              return _regeneratorRuntime.awrap(this.init());

            case 4:
              this.started = true;
              this.eventListeners.addListeners();

              if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
                this.intersectionObserver.observe(this.interactivity.element);
              }

              _iteratorNormalCompletion7 = true;
              _didIteratorError7 = false;
              _iteratorError7 = undefined;
              _context3.prev = 10;
              _iterator7 = this.plugins[Symbol.iterator]();

            case 12:
              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                _context3.next = 25;
                break;
              }

              _ref15 = _step7.value;
              _ref14 = _slicedToArray(_ref15, 2);
              plugin = _ref14[1];

              if (!(plugin.startAsync !== undefined)) {
                _context3.next = 21;
                break;
              }

              _context3.next = 19;
              return _regeneratorRuntime.awrap(plugin.startAsync());

            case 19:
              _context3.next = 22;
              break;

            case 21:
              if (plugin.start !== undefined) {
                plugin.start();
              }

            case 22:
              _iteratorNormalCompletion7 = true;
              _context3.next = 12;
              break;

            case 25:
              _context3.next = 31;
              break;

            case 27:
              _context3.prev = 27;
              _context3.t0 = _context3["catch"](10);
              _didIteratorError7 = true;
              _iteratorError7 = _context3.t0;

            case 31:
              _context3.prev = 31;
              _context3.prev = 32;

              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                _iterator7.return();
              }

            case 34:
              _context3.prev = 34;

              if (!_didIteratorError7) {
                _context3.next = 37;
                break;
              }

              throw _iteratorError7;

            case 37:
              return _context3.finish(34);

            case 38:
              return _context3.finish(31);

            case 39:
              this.play();

            case 40:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this, [[10, 27, 31, 39], [32,, 34, 38]]);
    }
  }, {
    key: "addClickHandler",
    value: function addClickHandler(callback) {
      var _this3 = this;

      var el = this.interactivity.element;

      if (!el) {
        return;
      }

      var clickOrTouchHandler = function clickOrTouchHandler(e, pos, radius) {
        if (_this3.destroyed) {
          return;
        }

        var pxRatio = _this3.retina.pixelRatio,
            posRetina = {
          x: pos.x * pxRatio,
          y: pos.y * pxRatio
        },
            particles = _this3.particles.quadTree.queryCircle(posRetina, radius * pxRatio);

        callback(e, particles);
      };

      var clickHandler = function clickHandler(e) {
        if (_this3.destroyed) {
          return;
        }

        var mouseEvent = e,
            pos = {
          x: mouseEvent.offsetX || mouseEvent.clientX,
          y: mouseEvent.offsetY || mouseEvent.clientY
        };
        clickOrTouchHandler(e, pos, 1);
      };

      var touchStartHandler = function touchStartHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = true;
        touchMoved = false;
      };

      var touchMoveHandler = function touchMoveHandler() {
        if (_this3.destroyed) {
          return;
        }

        touchMoved = true;
      };

      var touchEndHandler = function touchEndHandler(e) {
        var _a, _b, _c;

        if (_this3.destroyed) {
          return;
        }

        if (touched && !touchMoved) {
          var touchEvent = e;
          var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];

          if (!lastTouch) {
            lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - 1];

            if (!lastTouch) {
              return;
            }
          }

          var canvasRect = (_a = _this3.canvas.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
              pos = {
            x: lastTouch.clientX - ((_b = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) !== null && _b !== void 0 ? _b : 0),
            y: lastTouch.clientY - ((_c = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) !== null && _c !== void 0 ? _c : 0)
          };
          clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
        }

        touched = false;
        touchMoved = false;
      };

      var touchCancelHandler = function touchCancelHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = false;
        touchMoved = false;
      };

      var touched = false;
      var touchMoved = false;
      el.addEventListener("click", clickHandler);
      el.addEventListener("touchstart", touchStartHandler);
      el.addEventListener("touchmove", touchMoveHandler);
      el.addEventListener("touchend", touchEndHandler);
      el.addEventListener("touchcancel", touchCancelHandler);
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      this.particles.handleClickMode(mode);
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.plugins[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref18 = _step8.value;

          var _ref17 = _slicedToArray(_ref18, 2);

          var _plugin = _ref17[1];

          if (_plugin.handleClickMode) {
            _plugin.handleClickMode(mode);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  }, {
    key: "updateActualOptions",
    value: function updateActualOptions() {
      this.actualOptions.responsive = [];
      var newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
      this.actualOptions.setTheme(this.currentTheme);

      if (this.responsiveMaxWidth != newMaxWidth) {
        this.responsiveMaxWidth = newMaxWidth;
        return true;
      }

      return false;
    }
  }, {
    key: "init",
    value: function init() {
      var _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, preset, shapes, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, type, drawer, availablePlugins, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _ref27, _ref20, id, _plugin2, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _ref28, _ref22, _drawer, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _ref29, _ref24, _plugin3, pathOptions, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _ref30, _ref26, _plugin4;

      return _regeneratorRuntime.async(function init$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this._options = new Options(__classPrivateFieldGet(this, _Container_engine, "f"));
              _iteratorNormalCompletion9 = true;
              _didIteratorError9 = false;
              _iteratorError9 = undefined;
              _context4.prev = 4;

              for (_iterator9 = this.presets[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                preset = _step9.value;

                this._options.load(__classPrivateFieldGet(this, _Container_engine, "f").plugins.getPreset(preset));
              }

              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](4);
              _didIteratorError9 = true;
              _iteratorError9 = _context4.t0;

            case 12:
              _context4.prev = 12;
              _context4.prev = 13;

              if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                _iterator9.return();
              }

            case 15:
              _context4.prev = 15;

              if (!_didIteratorError9) {
                _context4.next = 18;
                break;
              }

              throw _iteratorError9;

            case 18:
              return _context4.finish(15);

            case 19:
              return _context4.finish(12);

            case 20:
              shapes = __classPrivateFieldGet(this, _Container_engine, "f").plugins.getSupportedShapes();
              _iteratorNormalCompletion10 = true;
              _didIteratorError10 = false;
              _iteratorError10 = undefined;
              _context4.prev = 24;

              for (_iterator10 = shapes[Symbol.iterator](); !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                type = _step10.value;
                drawer = __classPrivateFieldGet(this, _Container_engine, "f").plugins.getShapeDrawer(type);

                if (drawer) {
                  this.drawers.set(type, drawer);
                }
              }

              _context4.next = 32;
              break;

            case 28:
              _context4.prev = 28;
              _context4.t1 = _context4["catch"](24);
              _didIteratorError10 = true;
              _iteratorError10 = _context4.t1;

            case 32:
              _context4.prev = 32;
              _context4.prev = 33;

              if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                _iterator10.return();
              }

            case 35:
              _context4.prev = 35;

              if (!_didIteratorError10) {
                _context4.next = 38;
                break;
              }

              throw _iteratorError10;

            case 38:
              return _context4.finish(35);

            case 39:
              return _context4.finish(32);

            case 40:
              this._options.load(this._initialSourceOptions);

              this._options.load(this._sourceOptions);

              this.actualOptions = new Options(__classPrivateFieldGet(this, _Container_engine, "f"));
              this.actualOptions.load(this._options);
              this.retina.init();
              this.canvas.init();
              this.updateActualOptions();
              this.canvas.initBackground();
              this.canvas.resize();
              this.zLayers = this.actualOptions.zLayers;
              this.duration = getRangeValue(this.actualOptions.duration);
              this.lifeTime = 0;
              this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 120;
              availablePlugins = __classPrivateFieldGet(this, _Container_engine, "f").plugins.getAvailablePlugins(this);
              _iteratorNormalCompletion11 = true;
              _didIteratorError11 = false;
              _iteratorError11 = undefined;
              _context4.prev = 57;

              for (_iterator11 = availablePlugins[Symbol.iterator](); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                _ref27 = _step11.value;
                _ref20 = _slicedToArray(_ref27, 2);
                id = _ref20[0];
                _plugin2 = _ref20[1];
                this.plugins.set(id, _plugin2);
              }

              _context4.next = 65;
              break;

            case 61:
              _context4.prev = 61;
              _context4.t2 = _context4["catch"](57);
              _didIteratorError11 = true;
              _iteratorError11 = _context4.t2;

            case 65:
              _context4.prev = 65;
              _context4.prev = 66;

              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }

            case 68:
              _context4.prev = 68;

              if (!_didIteratorError11) {
                _context4.next = 71;
                break;
              }

              throw _iteratorError11;

            case 71:
              return _context4.finish(68);

            case 72:
              return _context4.finish(65);

            case 73:
              _iteratorNormalCompletion12 = true;
              _didIteratorError12 = false;
              _iteratorError12 = undefined;
              _context4.prev = 76;
              _iterator12 = this.drawers[Symbol.iterator]();

            case 78:
              if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                _context4.next = 88;
                break;
              }

              _ref28 = _step12.value;
              _ref22 = _slicedToArray(_ref28, 2);
              _drawer = _ref22[1];

              if (!_drawer.init) {
                _context4.next = 85;
                break;
              }

              _context4.next = 85;
              return _regeneratorRuntime.awrap(_drawer.init(this));

            case 85:
              _iteratorNormalCompletion12 = true;
              _context4.next = 78;
              break;

            case 88:
              _context4.next = 94;
              break;

            case 90:
              _context4.prev = 90;
              _context4.t3 = _context4["catch"](76);
              _didIteratorError12 = true;
              _iteratorError12 = _context4.t3;

            case 94:
              _context4.prev = 94;
              _context4.prev = 95;

              if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                _iterator12.return();
              }

            case 97:
              _context4.prev = 97;

              if (!_didIteratorError12) {
                _context4.next = 100;
                break;
              }

              throw _iteratorError12;

            case 100:
              return _context4.finish(97);

            case 101:
              return _context4.finish(94);

            case 102:
              _iteratorNormalCompletion13 = true;
              _didIteratorError13 = false;
              _iteratorError13 = undefined;
              _context4.prev = 105;
              _iterator13 = this.plugins[Symbol.iterator]();

            case 107:
              if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                _context4.next = 121;
                break;
              }

              _ref29 = _step13.value;
              _ref24 = _slicedToArray(_ref29, 2);
              _plugin3 = _ref24[1];

              if (!_plugin3.init) {
                _context4.next = 115;
                break;
              }

              _plugin3.init(this.actualOptions);

              _context4.next = 118;
              break;

            case 115:
              if (!(_plugin3.initAsync !== undefined)) {
                _context4.next = 118;
                break;
              }

              _context4.next = 118;
              return _regeneratorRuntime.awrap(_plugin3.initAsync(this.actualOptions));

            case 118:
              _iteratorNormalCompletion13 = true;
              _context4.next = 107;
              break;

            case 121:
              _context4.next = 127;
              break;

            case 123:
              _context4.prev = 123;
              _context4.t4 = _context4["catch"](105);
              _didIteratorError13 = true;
              _iteratorError13 = _context4.t4;

            case 127:
              _context4.prev = 127;
              _context4.prev = 128;

              if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
                _iterator13.return();
              }

            case 130:
              _context4.prev = 130;

              if (!_didIteratorError13) {
                _context4.next = 133;
                break;
              }

              throw _iteratorError13;

            case 133:
              return _context4.finish(130);

            case 134:
              return _context4.finish(127);

            case 135:
              pathOptions = this.actualOptions.particles.move.path;

              if (pathOptions.generator) {
                this.setPath(__classPrivateFieldGet(this, _Container_engine, "f").plugins.getPathGenerator(pathOptions.generator));
              }

              this.particles.init();
              this.particles.setDensity();
              _iteratorNormalCompletion14 = true;
              _didIteratorError14 = false;
              _iteratorError14 = undefined;
              _context4.prev = 142;

              for (_iterator14 = this.plugins[Symbol.iterator](); !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                _ref30 = _step14.value;
                _ref26 = _slicedToArray(_ref30, 2);
                _plugin4 = _ref26[1];

                if (_plugin4.particlesSetup !== undefined) {
                  _plugin4.particlesSetup();
                }
              }

              _context4.next = 150;
              break;

            case 146:
              _context4.prev = 146;
              _context4.t5 = _context4["catch"](142);
              _didIteratorError14 = true;
              _iteratorError14 = _context4.t5;

            case 150:
              _context4.prev = 150;
              _context4.prev = 151;

              if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
                _iterator14.return();
              }

            case 153:
              _context4.prev = 153;

              if (!_didIteratorError14) {
                _context4.next = 156;
                break;
              }

              throw _iteratorError14;

            case 156:
              return _context4.finish(153);

            case 157:
              return _context4.finish(150);

            case 158:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, [[4, 8, 12, 20], [13,, 15, 19], [24, 28, 32, 40], [33,, 35, 39], [57, 61, 65, 73], [66,, 68, 72], [76, 90, 94, 102], [95,, 97, 101], [105, 123, 127, 135], [128,, 130, 134], [142, 146, 150, 158], [151,, 153, 157]]);
    }
  }, {
    key: "intersectionManager",
    value: function intersectionManager(entries) {
      if (!this.actualOptions.pauseOnOutsideViewport) {
        return;
      }

      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = entries[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var entry = _step15.value;

          if (entry.target !== this.interactivity.element) {
            continue;
          }

          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "sourceOptions",
    get: function get() {
      return this._sourceOptions;
    }
  }]);

  return Container;
}();
_Container_engine = new WeakMap();